<script setup>
import { inject, onMounted, defineAsyncComponent } from 'vue'
import { useModal, useModalSlot } from 'vue-final-modal'
import DefaultModal from './DefaultModal.vue'

const emitter = inject('emitter')

const { open, close, patchOptions } = useModal({
    component: DefaultModal,
    attrs: {
        // title: 'Upraviť udalosť',
        onClose() { close() },
    },
    slots: {
        default: useModalSlot({
            component: DefaultModal,
            // attrs: {}
        })
    }
})

onMounted( () => emitter.on('showModal', (name) => handleModalSettings(name)))

const handleModalSettings = (name) => {
   patchOptions({
        slots: {
            default: useModalSlot({
                // import component based on name
                component: defineAsyncComponent(() => import(`./${name}.vue`)),
            })
        }
    })

    open()
}
</script>

<template></template>
